import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { getLanguage, initLanguage, setLanguage, t as translate } from '../services/I18nService'

const LanguageContext = createContext(null)

const LanguageProvider = ({ children }) => {
    const [locale, setLocale] = useState(getLanguage())

    useEffect(() => {
        initLanguage()
        const onLanguageChange = (e) => setLocale(e.detail.locale)
        window.addEventListener('languagechange', onLanguageChange)
        return () => window.removeEventListener('languagechange', onLanguageChange)
    }, [])

    const changeLanguage = (code) => {
        setLanguage(code)
        setLocale(code)
    }

    const t = useCallback((key, params) => translate(key, params), [])

    return (
        <LanguageContext.Provider value={{ locale, changeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    )
}

const useTranslation = () => {
    const ctx = useContext(LanguageContext)
    if (!ctx) {
        throw new Error('useTranslation must be used within LanguageProvider')
    }
    return ctx
}

export { LanguageProvider, useTranslation }
